import React from 'react'
import PropTypes from 'prop-types'
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil'

import {
  Card,
  Title,
  TITLE_VARIANT_S,
  Text,
  TEXT_VARIANT_LIGHT,
  Flex,
  FlexItem
} from 'mailup-web-components'

import {
  abTestState,
  isValidFormState,
  searchCriteriaState
} from 'Pages/AbTestWizard/recoil/state/abtest'
import { pageState } from 'Pages/AbTestWizard/recoil/state/page'

import { RECIPIENTS_NONE } from 'Pages/AbTestWizard/const'

const BoxRecipient = ({ recipient, title, description, icon, dataMuTest }) => {
  const [{ wizardStep, numberOfStepEnabled }, setPageState] = useRecoilState(
    pageState
  )
  const [{ step2 }, setAbTestState] = useRecoilState(abTestState)
  const resetSearchCriteria = useResetRecoilState(searchCriteriaState)
  const isValidForm = useRecoilValue(isValidFormState)

  const handleBoxClick = () => {
    resetSearchCriteria()
    setAbTestState(prev => ({
      ...prev,
      step3: {
        ...prev.step3,
        includeGroups: [],
        excludeGroups: [],
        selectedFilters: [],
        typeAppliedFilters: 'All'
      }
    }))

    const nextWizardStep =
      recipient !== RECIPIENTS_NONE && isValidForm ? 3 : wizardStep

    const newNumberOfStepEnabled =
      recipient !== RECIPIENTS_NONE && isValidForm ? 3 : numberOfStepEnabled

    setAbTestState(prev => ({
      ...prev,
      step2: {
        ...prev.step2,
        recipients: recipient
      }
    }))

    setPageState(prev => ({
      ...prev,
      wizardStep: nextWizardStep,
      numberOfStepEnabled: newNumberOfStepEnabled
    }))
  }

  return (
    <>
      <Card
        onClick={handleBoxClick}
        selected={step2.recipients === recipient}
        data-mu-test={dataMuTest}
      >
        <Flex flexDirection='column' alignItems='center'>
          {icon}
          <FlexItem margin='8px 0 0 0'>
            <Title variant={TITLE_VARIANT_S} textAlign='center'>
              {title}
            </Title>
          </FlexItem>
          <FlexItem margin='8px 0 0 0'>
            <Text variant={TEXT_VARIANT_LIGHT}>{description}</Text>
          </FlexItem>
        </Flex>
      </Card>
    </>
  )
}

BoxRecipient.propTypes = {
  recipient: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.any,
  dataMuTest: PropTypes.string
}

export default BoxRecipient
